export default __webpack_public_path__ + "static/media/right.f342faa2.svg";